import React from "react";
import Layout from "../../Layouts/Layout";
import CookiePolicy from "../../../components/CookiePolicy/CookiePolicy";
import Container from "../../../components/Container/Container";
import CookiePolicyPageMeta from "./CookiePolicyPageMeta";

const CookiePolicyPage = () => {
  return (
    <Layout>
      <Container showPaddingBlock={false}>
        <CookiePolicyPageMeta />
        <CookiePolicy />
      </Container>
    </Layout>
  );
};
export default CookiePolicyPage;
